<script>
import { Bilety24EventDate } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      includeActions: false,
      hideSidebar: true,
      verboseName: 'Wydarzenie',
      verboseNamePlural: 'Wydarzenia',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title_pl', label: 'tytuł (pl)' },
        { prop: 'title_en', label: 'tytuł (en)' },
        { label: 'data', formatter: this.formatDate('date') },
        { label: 'pasujące wydarzenie', type: 'event' }
      ]
    }
  },
  computed: {
    service() {
      return Bilety24EventDate
    }
  },
  watch: {
    items: {
      deep: true,
      handler(value) {
        const index = value.findIndex(item => !!item.event)
        if (index > -1) {
          this.items.splice(index, 1)
          this.fetchData()
        }
      }
    }
  },
  created() {
    this.$store.dispatch('fetchEventsToAssignBilety24')
  }
}
</script>
